__turbopack_context__.v({
  "actions": "ProjectCreatedSuccess-module-scss-module__Jcp6TG__actions",
  "checkmark": "ProjectCreatedSuccess-module-scss-module__Jcp6TG__checkmark",
  "content": "ProjectCreatedSuccess-module-scss-module__Jcp6TG__content",
  "description": "ProjectCreatedSuccess-module-scss-module__Jcp6TG__description",
  "iconPrimary": "ProjectCreatedSuccess-module-scss-module__Jcp6TG__iconPrimary",
  "iconSecondary": "ProjectCreatedSuccess-module-scss-module__Jcp6TG__iconSecondary",
  "iconTertiary": "ProjectCreatedSuccess-module-scss-module__Jcp6TG__iconTertiary",
  "nextSteps": "ProjectCreatedSuccess-module-scss-module__Jcp6TG__nextSteps",
  "nextStepsLabel": "ProjectCreatedSuccess-module-scss-module__Jcp6TG__nextStepsLabel",
  "stepArrow": "ProjectCreatedSuccess-module-scss-module__Jcp6TG__stepArrow",
  "stepDescription": "ProjectCreatedSuccess-module-scss-module__Jcp6TG__stepDescription",
  "stepIconWrapper": "ProjectCreatedSuccess-module-scss-module__Jcp6TG__stepIconWrapper",
  "stepItem": "ProjectCreatedSuccess-module-scss-module__Jcp6TG__stepItem",
  "stepItemDisabled": "ProjectCreatedSuccess-module-scss-module__Jcp6TG__stepItemDisabled",
  "stepItemHighlighted": "ProjectCreatedSuccess-module-scss-module__Jcp6TG__stepItemHighlighted",
  "stepText": "ProjectCreatedSuccess-module-scss-module__Jcp6TG__stepText",
  "stepTitle": "ProjectCreatedSuccess-module-scss-module__Jcp6TG__stepTitle",
  "stepsList": "ProjectCreatedSuccess-module-scss-module__Jcp6TG__stepsList",
  "title": "ProjectCreatedSuccess-module-scss-module__Jcp6TG__title",
  "wrapper": "ProjectCreatedSuccess-module-scss-module__Jcp6TG__wrapper",
});
